import { defineNuxtPlugin } from "nuxt/app";
import Auth from "../utils/auth";

export default defineNuxtPlugin({
  name: "ckweb:auth",
  dependsOn: ["ckweb:settings", "ckweb:dev-console"],
  async setup() {
    const config = useRuntimeConfig();

    const auth = new Auth(config);

    devConsole.info("🛠️ ckAuth: $auth created 🚀🚀🚀🚀🚀");

    return {
      provide: {
        auth,
      },
    };
  },
});
